import { loadExam } from "../../Viewer/Exam";
import { AbLoads } from "../../Viewer/LoadExam/AbLoads";


export function loadTest(){
    AbLoads()
    loadExam()
}